/**
 * Wilson MUI Class Name Prefix Configuration
 *
 * IMPORTANT: This file must be imported BEFORE any MUI components are loaded.
 * It configures MUI to prefix all semantic class names:
 *   MuiButton-root -> Wilson-MuiButton-root
 *
 * Styles and tests select MUI elements by these prefixed class names.
 *
 * Usage: Import this as a side-effect in your app's entry point:
 *   import 'dpl/config/classNameGenerator'
 *   import { App } from './App' // Now safe to import MUI components
 *
 * @see https://mui.com/material-ui/guides/classname-generator/
 */
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className'

export const WILSON_PREFIX = 'Wilson-'

// Use a global flag to prevent HMR from re-configuring
const CONFIGURED_KEY = '__WILSON_MUI_CONFIGURED__'

if (typeof window !== 'undefined' && !(window as any)[CONFIGURED_KEY]) {
  ;(window as any)[CONFIGURED_KEY] = true

  ClassNameGenerator.configure(componentName => {
    // Only prefix if it starts with 'Mui' (standard MUI component names)
    if (componentName.startsWith('Mui')) {
      return `${WILSON_PREFIX}${componentName}`
    }
    // Return as-is for already-prefixed or non-standard names
    return componentName
  })
}
